export const Failed_Load = 'Failed_Load';
export const Push_AccuRanker_Data = 'Push_AccuRanker_Data';
export const Get_AccuRanker_Data = 'Get_AccuRanker_Data';
export const Clear_Google_Sheet_Data = 'Clear_Google_Sheet_Data';
export const UPDATE_GRID = 'UPDATE_GRID';
export const FILTER_ROWS = 'FILTER_ROWS';
export const STORE_REF_DATA = "STORE_REF_DATA";
export const SET_CDP_DATA = 'SET_CDP_DATA';
export const UPLOAD_CSV_DATA = 'UPLOAD_CSV_DATA';
